import Chip from "@mui/material/Chip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { MaintenanceDisplayData } from "@/models/MaintenanceDisplayData";

const WorkOrderCell = (params: GridRenderCellParams<MaintenanceDisplayData, string>) => {
  const severityCode = params?.row?.workOrderJob?.severityCode ?? 0;

  const color: "default" | "primary" | "warning" | "error" =
    severityCode <= 100 ? "primary" : severityCode <= 300 ? "warning" : "error";

  return params?.formattedValue ? (
    <Chip label={params?.formattedValue} color={color} size="small" />
  ) : (
    <></>
  );
};

export default WorkOrderCell;
